import { gql } from '@apollo/client'

export const GET_STATISTICS = gql`
  query {
    statistics {
      sms_sent
    }
  }
`
